<template>
  <div :class="['content-taxonomy', getTheme, getSize]">
    <div v-for="(topic, index) in topics" :key="index" class="content-taxonomy__topic">
      {{ topic }}
    </div>
    <div class="content-taxonomy__contenttype">
      {{ contentType }}
    </div>
  </div>
</template>

<script>
  export default {
    name: 'content-taxonomy',
    props: {
      theme: {
        type: String,
        default: 'default'
      },
      size: {
        type: String,
        default: 'small'
      },
      topics: {
        type: Array,
        default: () => []
      },
      contentType: {
        type: String,
        default: null
      }
    },
    computed: {
      getTheme() {
        return `content-taxonomy--${this.theme}`
      },
      getSize() {
        return `content-taxonomy--${this.size}`
      }
    }
  }
</script>

<style lang="scss" scoped>
  .content-taxonomy {
    $wrap: &;
    margin: 10px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    color: #1d2822;

    &__topic {
      // margin-right: 10px;
      // padding: 0 0 0 10px;
      text-transform: uppercase;
      font-weight: 600;
      padding-right: 10px;

      &:not(:first-child) 
      {
        &::before {
          content: '/';
          margin-right: 2px;
          color: #9ddda9;
        }
      }
    }

    &__contenttype {
      // margin-left: 15px;
      color: #999;
      line-height: 1em;
      font-style: normal;
      font-weight: 400;
      border-radius: 2px;
      border: 1px solid #999;
      padding: 4px 5px;
      text-transform: capitalize;
    }

    &--small {
      font-size: 1em;
    }

    &--medium {
      @media (min-width: 992px) {
        font-size: 1.25em;
      }
    }

    &--large {
      @media (min-width: 992px) {
        font-size: 1.25em;
      }
      @media (min-width: 1200px) {
        font-size: 1.5em;
      }
    }

    &--white {
      color: #FFF;

      #{$wrap}__topic {
        &:not(:first-child) 
        {
          &::before {
            color: #FFF;
          }
        }
      }

      #{$wrap}__contenttype {
        color: #FFF;
      }
    }
  }
</style>